import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

function MisionVision() {
  return (
    <>
      <Navbar />
        <div>MisionVision</div>
      <Footer />
    </>

  )
}

export default MisionVision